import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-open-page',
  imports: [],
  templateUrl: './open-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './open-page.component.scss',
})
export class OpenPageComponent {}
